// app/javascript/controllers/accordion_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "answer"]

  toggle(event) {
    const index = event.currentTarget.dataset.index
    const answer = this.answerTargets.find(el => el.dataset.index === index)
    const button = this.buttonTargets.find(el => el.dataset.index === index)

    const isOpen = answer.classList.contains("block")

    // Close all
    this.answerTargets.forEach(el => {
      el.classList.add("hidden")
      el.classList.remove("block")
    })
    this.buttonTargets.forEach(btn => btn.setAttribute("aria-expanded", "false"))

    // Toggle clicked one
    if (!isOpen) {
      answer.classList.remove("hidden")
      answer.classList.add("block")
      button.setAttribute("aria-expanded", "true")
    }
  }
}
